import React, { useId } from 'react';
import { Box, Link, Typography } from '@mui/material';
import type { DemoLocale } from './demoData';
import type { TeaserObservation } from './buildingTeaserData';
import { colors, fonts } from './design';
import { publicPath } from './routes';

export function TeaserRecommendations({ finding, locale, showContact = true }: {
  finding: TeaserObservation; locale: DemoLocale; showContact?: boolean;
}) {
  const id = useId();
  const en = locale === 'en';
  return <Box sx={{ mt: 2.5 }}>
    <Typography sx={{ fontSize: 12, color: colors.muted, mb: 1.5 }}>
      {en
        ? 'Illustrative recommendations — not a completed AI analysis or expert assessment of this finding.'
        : 'Rekommendationerna är exempel — inte en utförd AI-analys eller expertbedömning av fyndet.'}
    </Typography>
    <Box component="section" aria-labelledby={`${id}-system`} sx={{ p: 2, bgcolor: colors.paper, borderLeft: `2px solid ${colors.muted}` }}>
      <Typography sx={{ fontFamily: fonts.mono, fontSize: 11, color: colors.muted, mb: .75 }}>
        {en ? 'SYSTEM GUIDANCE / EXAMPLE' : 'SYSTEMSTÖD / EXEMPEL'}
      </Typography>
      <Typography component="h4" id={`${id}-system`} sx={{ fontWeight: 700, mb: 1 }}>
        BI – Building Intelligence
      </Typography>
      <Typography sx={{ fontSize: 15 }}>{finding.next}</Typography>
    </Box>
    <Box component="section" aria-labelledby={`${id}-engineer`} sx={{ p: 2, mt: 1.5, bgcolor: colors.paper, borderLeft: `2px solid ${colors.rust}` }}>
      <Typography sx={{ fontFamily: fonts.mono, fontSize: 11, color: colors.rust, mb: .75 }}>
        {en ? 'EXPERT / HUMAN ASSESSMENT' : 'EXPERT / MÄNSKLIG BEDÖMNING'}
      </Typography>
      <Typography component="h4" id={`${id}-engineer`} sx={{ fontWeight: 700, mb: 1 }}>
        {en ? 'Building engineer' : 'Byggnadsingenjör'}
      </Typography>
      <Typography sx={{ fontSize: 15 }}>{finding.expertRecommendation}</Typography>
      <Typography sx={{ fontSize: 12, color: colors.muted, mt: 1.5 }}>
        {en
          ? 'Expert adds independent engineering review and technical documentation within the agreed scope.'
          : 'Expert tillför oberoende ingenjörsgranskning och tekniskt underlag inom avtalad omfattning.'}
      </Typography>
      {showContact && <Link href={`${publicPath('contact', locale)}?service=expert`}
        sx={{ display: 'inline-flex', alignItems: 'center', minHeight: 44, mt: .5, fontSize: 14 }}>
        {en ? 'Discuss Expert with us' : 'Prata med oss om Expert'}
      </Link>}
    </Box>
  </Box>;
}
